export default "__VITE_ASSET__18608451__"